import type { RevenueDisplayMode } from "@productlane/db"

import { getCurrencySymbol } from "./currency"

export function formatRevenue({
	revenue, // keep in mind that we store revenue as annual value
	revenueFormatting,
	currency,
}: {
	revenue: number
	revenueFormatting: RevenueDisplayMode
	currency?: string | null
}) {
	const value = revenueFormatting === "ANNUAL" ? revenue : revenue / 12
	const prefix = currency === undefined ? "" : getCurrencySymbol(currency)

	if (value >= 1_000_000) {
		// millions
		return `${prefix}${(value / 1_000_000).toFixed(1)}M`
	} else if (value >= 1_000) {
		// thousands
		return `${prefix}${(value / 1_000).toFixed(1)}K`
	}
	return `${prefix}${Math.round(value)}`
}
